import React, { Component } from "react";
//import React, { useState, useEffect } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "../components/Grid/GridItem.jsx";
import GridContainer from "../components/Grid/GridContainer.jsx";
import Table from "./InspectorTable";
import Card from "../components/Card/Card.jsx";
import CardHeader from "../components/Card/CardHeader.jsx";
import CardBody from "../components/Card/CardBody.jsx";
import { withApollo } from "react-apollo";
import { flowRight } from "lodash";

import gql from "graphql-tag";
import { spinnerService } from "@chevtek/react-spinners";
import { connect } from "react-redux";
import * as actionTypes from "../redux/actions";
import { styles } from '../assets/css/styles'
import { LIST_INSPECTORS } from '../config/myqueries';

class Inspector extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    customer: {},
    inspectors: [],
    uniqueVehicles: [],
    vehAdded: false,
    start: 0,
    end: 10,
    nextToken: undefined,
    preToken: [],
    limit: 20,
    pre: 0
  };
  loadData = async (nextToken) => {
    const { client, user } = this.props;
    let { limit } = this.state;
    spinnerService.show("mySpinner");
    if (user) {
      try {
        const listInspectors = await client.query({
          query: gql(LIST_INSPECTORS),
          fetchPolicy: `network-only`,
          variables: { limit, nextToken }
        });
        this.setState({
          inspectors: listInspectors.data.listInspectors.items,
          nextToken: listInspectors.data.listInspectors.nextToken,
        });
        spinnerService.hide("mySpinner");
      } catch (err) {
        spinnerService.hide("mySpinner");
      }
    } else {
      spinnerService.hide("mySpinner");
    }
  }
  async componentDidMount() {
    this.loadData(undefined)
  }
  changePage = (i) => {
    let start = i * 10 - 10, end = (i * 10);
    this.setState({ start, end })
  }
  nextClick = () => {
    let { nextToken, preToken, pre } = this.state;
    if (nextToken !== undefined && nextToken !== null) {
      preToken.push(nextToken);
      this.setState({ preToken, pre })
      this.loadData(nextToken)
    }
  }
  preClick = () => {
    let { preToken } = this.state;
    let nextToken = preToken.pop();
    nextToken = preToken.pop();
    this.setState({ nextToken })
    this.loadData(nextToken)
  }
  render() {
    const { classes, client } = this.props;
    const { inspectors } = this.state;
    return (
      <React.Fragment>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>List of Inspectors</h4>
                <p className={classes.cardCategoryWhite}>Details</p>
              </CardHeader>
              <CardBody style={{ minHeight: 1050 }}>
                {inspectors.length !== 0 ? (
                  <Table
                    tableHeaderColor="primary"
                    tableHead={[
                      "Name",
                      "Email",
                      "Experience",
                      "Details",
                      "Assign Vehicles"
                    ]}
                    tableData={inspectors}
                    type={"inspectors"}
                    client={client}
                  />
                ) : null}
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        {inspectors.length > 0 && <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            {/* <Pagination onPageSelect={this.changePage} start={start} data={inspectors} /> */}
            <div >
              <span className='pagination' onClick={this.preClick}>{`<<Previous`}</span>
              <span style={{ float: 'left' }}>|</span>
              <span className='pagination' onClick={this.nextClick}>Next>></span>
            </div>
          </GridItem>
        </GridContainer>}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    loading: state.inspections.loading,
    data: state.inspections.data
  };
};
const mapDispatchToProps = dispatch => {
  return {
    // addCounter: (id) => dispatch({type:actionTypes.Add_Counter, val:id}),
    storeInspection: data =>
      dispatch({ type: actionTypes.STORE_INSPECTION, data: data }),
    // fetchInspection: () => dispatch(actionTypes.fetchInspection_AC()),
    requestInspection: () => dispatch(actionTypes.requestInspection())
  };
};
export default Inspector = connect(
  mapStateToProps,
  mapDispatchToProps
)(flowRight(withApollo)(withStyles(styles)(Inspector)));



// WEBPACK FOOTER //
// ./src/admin/Inspector.js